// extracted by mini-css-extract-plugin
export default {"PasswordResetEmail":"zl_a bik_qt bik_a bik_w bik_ea bik_ti","PasswordResetEmail__title":"zl_b bik_vp bik_rg bik_va","PasswordResetEmail__subtitle":"zl_c bik_va"};